module.exports = __webpack_public_path__ + "static/ManipulaTHOR_Light-725466cd9f87dcb93ce3b05583be0111.svg";